import { useTranslation } from 'react-i18next';
import React, { useState, useEffect, Fragment, useRef } from 'react';
import MasterStamm from "../MasterStammComponent/MasterStamm";
import DetailsBox from "../shared/components/DetailsBox";
import { Typography, Button, Box, Grid } from "@mui/material";
import ResponsiveDialog from '../shared/components/ResponsiveDialog'
import { Mitarbeiterauswahl, } from '../lib';
import apiRequest from '../../functions/api';
import LoadingComponent from '../LoadingComponent/LoadingComponent';
import { useMessage } from '../../context/message-context';
import { DateTextField } from "../lib";
import InputBox from '../shared/components/InputBox';
import MessageBox from "../shared/components/MessageBox";
import DynamicTable from "../shared/components/DynamicTableComponent";
import { pad } from "../../functions/default";
import TurnusAuswahl from '../shared/components/TurnusAuswahl';
import AblagenamenAuswahl from '../shared/components/AblagenamenAuswahl';
import { FullPageSpinner } from "../lib";
import openFile from "../shared/functions/download";
import axios from 'axios';
import { API_BASE_URL } from '../../constants/apiConstants';
function HRQualifikation(props) {
  const { t } = useTranslation();
  const { accessToken, client, } = props;
  const [open, setOpen] = useState(false);
  const [dialog, setDialog] = useState(false);
  const [dialogpersonen, setDialogpersonen] = useState(false);
  const [stamm, setStamm] = useState([]);
  const zeilenauswahl = useRef("");
  const spaltenauswahl = useRef("");
  const [openibox, setOpenIBox] = useState(false);
  const [mitarbeiter, setMitarbeiter] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const { hideMessage, showErrorMessage, showSuccessMessage } = useMessage();
  const [zuorddat, setZuordDat] = useState("");
  const [fragen, setFragen] = useState([]);
  const [iboxtitle, setIBoxTitle] = useState("");
  const [auswertung, setAuswertung] = useState([]);
  const [showauswertung, setShowAuswertung] = useState(false);
  const [options, setOptions] = useState([]);
  const [auswahl, setAuswahl] = useState("");
  const [personen, setPersonen] = useState([]);
  const [ansichtstatus, setAnsichtstatus] = useState("");
  const [qualifikation, setQualifikation] = useState("");
  const [aenderung, setAenderung] = useState("");
  const [messageopen, setMessageOpen] = useState("");
  const [turnusopen, setTurnusOpen] = useState(false);
  const [turnuskey, setTurnusKey] = useState("");
  const [selectedFile, setSelectedFile] = useState([]);
  const [spin, setSpin] = useState(false);
  const [hdokopen, setHDOKOpen] = useState(false);
  const [ablagekey, setAblageKey] = useState("");
  const [loeschenbox, setLoeschenBox] = useState(false);
  const errorcB = () => {
    setIsLoading(false);
    showErrorMessage(t("Keine Internetverbindung. Bitte erneut versuchen"));
  }
  const handleResponse = (result) => {
    if (spaltenauswahl.current !== "LOESCHEN") { setMessageOpen(false); return }
    if (spaltenauswahl.current === "LOESCHEN") {
      setLoeschenBox(false);
      if (result === "YES") {
        buttonAnfrage("BUTTON_SPEICHERN", spaltenauswahl.current, zeilenauswahl.current)
      }
    }
  }
  const anfrageCB = (response) => {
    setSpin(false);
    setIsLoading(false);
    setOpenIBox(false);
    if (response.status === 200) {
      setZuordDat("");
      if (response.data.message) {
        if (response.data.message !== "ok") {
          showSuccessMessage(response.data.message);
        }
      }
      if (response.data.stamm) {
        setStamm(response.data.stamm);
      }
      if (response.data.fragen) {
        setFragen(response.data.fragen);
        setTurnusKey("");
        setAblageKey("");
        setOpenIBox(true);
      }
      if (response.data.titel) {
        setIBoxTitle(response.data.titel);
      }
      if (response.data.auswertung) {
        setAuswertung(response.data.auswertung);
        setShowAuswertung(true)
      }
      if (response.data.ansichtstatus) {
        setAnsichtstatus(response.data.ansichtstatus);
      }
      if (response.data.personen) {
        setPersonen(response.data.personen);
        setDialogpersonen(true);
        setAenderung('');
        setZuordDat(new Date().getFullYear().toString() + "-" + pad(new Date().getMonth() + 1, 2) + "-" + pad(new Date().getDate(), 2));
      }
      if (response.data.qualibez) {
        setQualifikation(response.data.qualibez);
      }
    } else {
      if (response) {
        showErrorMessage(response.data.message);
      } else {
        showErrorMessage(t("Keine Internetverbindung"));
      }
    }
  }
  const buttonAnfrage = (statement, button, key) => {
    setIsLoading(true);
    const payload = {
      "mandant": client,
      "program": "HRQUAL",
      "statement": statement,
      "button": button,
      "key": key,
      "ansichtstatus": ansichtstatus,
    }
    const headers = {
      "Authorization": "Bearer " + accessToken,
    }
    apiRequest('POST', 'daten', payload, headers, anfrageCB, errorcB);
  }
  const Zuordnen = () => {
    setSpin(true);
    const payload = {
      "mandant": client,
      "program": "HRQUAL",
      "statement": "BUTTON_SPEICHERN",
      "button": "ZUORDNEN",
      "key": zeilenauswahl.current,
      "mitarbeiter": mitarbeiter,
      "zeitraum": zuorddat,
      "ansichtstatus": ansichtstatus,
    }
    const data = new FormData();
    hideMessage();
    for (let index = 0; index < selectedFile.length; index++) {
      data.append('file', selectedFile[index]);
    }
    data.append('payload', JSON.stringify(payload));
    const headers = {
      "Authorization": "Bearer " + accessToken,
      "Mandant": client,
      "Program": "HRQUAL",
      "Statement": "BUTTON_SPEICHERN",
    }
    apiRequest('POST', 'upload', data, headers, anfrageCB, errorcB);
  }
  const ZuordnenPersonen = () => {
    setIsLoading(true);
    const payload = {
      "mandant": client,
      "program": "HRQUAL",
      "statement": "BUTTON_SPEICHERN",
      "button": "ZUORDVERW",
      "key": zeilenauswahl.current,
      "personen": personen,
      "zeitraum": zuorddat,
    }
    const headers = {
      "Authorization": "Bearer " + accessToken,
    }
    apiRequest('POST', 'daten', payload, headers, anfrageCB, errorcB);
  }
  const buttonEnde = (spaltenkey) => {
    switch (spaltenkey) {
      case "ZUORNDEN":
        setDialog(false);
        Zuordnen();
        break;
      case "ZUORDVERW":
        if (zuorddat !== "") {
          setDialogpersonen(false);
          ZuordnenPersonen();
        } else {
          setMessageOpen(true);
        }
        break;
      default:
        break;
    }
  }
  const inputBoxResult = (results, files) => {
    // console.log(Object.keys(files));
    setIsLoading(true);
    // hideMessage();
    const data = new FormData();
    Object.keys(files).map((element, index) => {
      data.append(element.toString(), files[element]);
    })
  
    const payload = {
      "mandant": client, // this.props.client,
      "program": "HRQUAL",
      "button": spaltenauswahl.current,
      "key": zeilenauswahl.current,
      "statement": "BUTTON_SPEICHERN",
      "antworten": results,
      "ansichtstatus": ansichtstatus,
      "turnuskey": turnuskey,
      "hdokkey": ablagekey
    }
    data.append("payload", JSON.stringify(payload));
    const headers = {
      "Authorization": "Bearer " + accessToken,
    }
    apiRequest('POST', 'daten', data, headers, anfrageCB, errorcB);
  }
  const DokumentOeffnen = (dokumentenkey) => {
    setSpin(true)
    const payload = {
      "mandant": client,
      "program": "HRQUAL",
      "statement": "DOKUMENT_ANZEIGEN",
      "key": zeilenauswahl.current,
      "Doknummer": dokumentenkey,
    }
    const headers = {
      "Authorization": "Bearer " + accessToken,
      "Accept": "application/pdf"
    }
    axios.post(API_BASE_URL + 'daten', payload, { headers: headers, responseType: 'blob' })
      .then((response) => {
        var fileName = dokumentenkey;
        var contentFile = response.data;
        const mimeType = response.headers['content-type'] || 'application/pdf'
        openFile(fileName, contentFile, mimeType);
        setSpin(false);
      })
      .catch(function (error) {
        showErrorMessage(t("Ein Fehler ist aufgetreten. Bitte versuchen Sie den download erneut."));
        setSpin(false);
      })
  }
  const lade_dokument = (dokumentenkey) => {
    DokumentOeffnen(dokumentenkey)
  }
  const IboxButtonClick = (button, buttonkey) => {
    console.log("button: ",button);
    console.log("buttonkey: ",buttonkey);
    if (button === "TURNUS") {
      setTurnusOpen(true)
    }
    if (button === "DMSDOK") {
      lade_dokument(buttonkey);
    }
    if (button === "HDOK") {
      setHDOKOpen(true)
    }
  
  }
  const buttonClick = (spaltenkey, zeilenkey) => {
    setZuordDat(new Date().getFullYear().toString() + "-" + pad(new Date().getMonth() + 1, 2) + "-" + pad(new Date().getDate(), 2));
    switch (spaltenkey) {
      case "ZUORDNEN":
        zeilenauswahl.current = zeilenkey
        spaltenauswahl.current = spaltenkey
        setSelectedFile([]);
        setDialog(true);
        break;
      case "LOESCHEN":
        zeilenauswahl.current = zeilenkey
        spaltenauswahl.current = spaltenkey
        setLoeschenBox(true);
        break;
      default:
        zeilenauswahl.current = zeilenkey
        spaltenauswahl.current = spaltenkey
        buttonAnfrage("BUTTON_START", spaltenkey, zeilenkey)
        break;
    }
  }
  const personenButtonClick = (spaltenkey, zeilenkey, persausw,) => {
    var zaehler = personen.tabelle.findIndex((element) => element.key === zeilenkey);
    if (personen.tabelle[zaehler][spaltenkey]) {
      if (personen.tabelle[zaehler][spaltenkey] === "1") { personen.tabelle[zaehler][spaltenkey] = "0"; setAenderung("personen" + zaehler + "0"); return }
      if (personen.tabelle[zaehler][spaltenkey] === "0") { personen.tabelle[zaehler][spaltenkey] = "1"; setAenderung("personen" + zaehler + "1"); return }
    }
  }
  const onChangeHandler = (event) => {
    setSelectedFile([...event.target.files]);
    setAenderung("file" + [...event.target.files])
  }
  return (
    <Fragment>
      <MasterStamm accessToken={accessToken} client={client} pvxprogramm={"HRQUAL"} buttonClick={buttonClick} stamm={stamm} setStamm={setStamm} auswahl={auswahl} setAuswahl={setAuswahl} ansichtstatus={ansichtstatus} setAnsichtstatus={setAnsichtstatus} StartFilter={"0"}></MasterStamm>
      <MessageBox
        open={loeschenbox}
        handleResponse={handleResponse}
        buttons="YESNO"
        text={"Soll die Zuordnung des MItarbeiters wirklich gelöscht werden?"}
        title={t("Löschbestätigung")}
        onClose={() => setLoeschenBox(false)}
      />
      <DetailsBox
        open={open}
        details={stamm?.[spaltenauswahl.current]?.[zeilenauswahl.current]}
        title={t("Detailsansicht")}
        onClose={() => setOpen(false)}
      />
      <ResponsiveDialog
        title={t("Mitarbeiterauswahl")}
        open={dialog}
        setOpen={(o) => { setDialog(false) }}
      >
        <Box p={1}>
          <Typography>{t("Welcher Person soll die Qualifikation zugeordnet werden?")}</Typography>
          <Mitarbeiterauswahl austritt="J" programm={"HRQUAL"} client={client} onChange={(value) => setMitarbeiter(value)} />
        </Box>
        <Box p={1}>
          <Typography>{t("Zu welchem Zeitpunkt hat die Person die Qualifikation erworben?")}</Typography>
          <DateTextField
            fullWidth
            onChange={(e) => setZuordDat(e.target.value)}
            value={zuorddat}
            variant="outlined"
            InputLabelProps={{
              shrink: true,
            }}
          />
        </Box>
        {stamm?.hdok?.[auswahl] &&
          <Box p={1}>
            <div>
              <Grid item xs={12}>
                <input
                  color="primary"
                  type="file"
                  id="file-input"
                  onChange={(event) => onChangeHandler(event)}
                  style={{ display: 'none' }}
                />
                <label htmlFor="file-input" className="mr-2">
                  <Button
                    id="Dateiupload"
                    variant="outlined"
                    component="span"
                    color="primary"
                    label={t("Dateiupload")}
                    fullWidth
                  >
                    {t("Datei auswählen")}
                  </Button>
                </label>
              </Grid>
              {selectedFile.length > 0 &&
                selectedFile.map((file) => {
                  return (
                    <Grid item xs={12}>
                      <Typography variant="body1" align={"center"} >
                        {"Ausgewählte Datei: " + file.name}
                      </Typography>
                    </Grid>
                  )
                })
              }
            </div>
          </Box>
        }
        <Button variant="contained" color="primary" onClick={() => buttonEnde("ZUORNDEN")} >{t("Zuordnen")}</Button>
        <Button color="primary" onClick={() => setDialog(false)} >{t("Abbrechen")}</Button>
      </ResponsiveDialog>
      <ResponsiveDialog
        title={t("Qualifikation - Personenverwaltung")}
        open={dialogpersonen}
        setOpen={(o) => { setDialogpersonen(false) }}
      >
        <Box p={1}>
          <Typography>{"Welche Personen sollen für die Qualifikation " + qualifikation + " zugeordnet werden?"}</Typography>
          <DynamicTable
            zeilen={personen?.tabelle}
            spalten={personen?.ueber}
            leertext={"keine Mitarbeiter gefunden"}
            hoehe={450}
            buttonCb={(spaltenkey, zeilenkey, zeilenlfd) => personenButtonClick(spaltenkey, zeilenkey, zeilenlfd)}
            minbreite={500}
            options={options}
            size={"small"}
            suche={"GESAMT"} />
        </Box>
        <Box p={1}>
          <Typography>{t("Zu welchem Zeitpunkt soll bei den Personen die Qualifikation als erworben gekennzeichnet werden?")}</Typography>
          <DateTextField
            fullWidth
            onChange={(e) => setZuordDat(e.target.value)}
            value={zuorddat}
            variant="outlined"
            InputLabelProps={{
              shrink: true,
            }}
          />
        </Box>
        {aenderung !== "" &&
          <Button variant="contained" color="primary" onClick={() => buttonEnde("ZUORDVERW")} >{t("Zuordnen")}</Button>
        }
        <Button color="primary" onClick={() => setDialogpersonen(false)} >{t("Abbrechen")}</Button>
        <MessageBox
          open={messageopen}
          handleResponse={handleResponse}
          text={t("Bitte alle Fragen vor der Zuordnung beantworten!")}
          title={t("Hinweis")}
          onClose={() => setMessageOpen(false)}
        />
      </ResponsiveDialog>
      <ResponsiveDialog
        title={t("Auswertung")}
        open={showauswertung}
        setOpen={(o) => { setShowAuswertung(false) }}
      >
        <Fragment>
          {auswertung?.info &&
            <Box p={1}>
              <Typography>{auswertung?.info}</Typography>
            </Box>
          }
          <Box p={1}>
            <DynamicTable zeilen={auswertung?.tabelle} spalten={auswertung?.ueber} leertext={"keine Mitarbeiter gefunden"} hoehe={700} buttonCb={(spaltenkey, zeilenkey) => buttonClick(spaltenkey, zeilenkey,)} minbreite={500} options={options} size={"small"} />
          </Box>
        </Fragment>
        <Button color="primary" onClick={() => setShowAuswertung(false)} >{t("Schließen")}</Button>
      </ResponsiveDialog>
      <InputBox
        open={openibox}
        handleResponse={inputBoxResult}
        fragen={fragen}
        title={iboxtitle}
        onClose={() => setOpenIBox(false)}
        turnuskey={turnuskey}
        hdokkey={ablagekey}
        buttonClick={(button, buttonkey ) => IboxButtonClick(button, buttonkey)}
      />
      <ResponsiveDialog
        title={t("Turnuseinstellungen")}
        open={turnusopen}
        setOpen={(o) => { setTurnusOpen(false) }}
      >
        <TurnusAuswahl
          accessToken={accessToken} client={client} programm="HRQUAL"
          setTurnusKey={setTurnusKey} setOpen={setTurnusOpen}
          startTurnus={turnuskey ? turnuskey : stamm?.turnus?.[zeilenauswahl.current] ? stamm?.turnus?.[zeilenauswahl.current] : ""}
        >
        </TurnusAuswahl>
      </ResponsiveDialog>
      <AblagenamenAuswahl accessToken={accessToken} client={client} programm="HRQUAL" setHDOKOpen={setHDOKOpen} hdokopen={hdokopen} setAblageKey={setAblageKey} archiv={"PERSM"} starthdok={ablagekey ? ablagekey : ""} />
      {spin &&
        <FullPageSpinner />
      }
    </Fragment>
  )
}
export default HRQualifikation;
